<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{ title }}</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
</div>

<div class="modal-body">
  <ng-container *ngIf="isSuccess; else confirmTemplate">
    <div class="success-container text-center">
      <div class="checkmark-wrapper">
        <div class="confetti-background"></div>
        <div class="checkmark-circle">
          <span class="checkmark">✓</span>
        </div>
      </div>
      <h3 class="mt-4">Thank you!</h3>
      <p class="text-muted">You have successfully submitted the exam.</p>
    </div>
  </ng-container>  
  <ng-template #confirmTemplate>
    <p><strong>{{ prefixMessage }} <span class="text-primary">"{{ message }}"</span>{{ !suffixMessage ? '?' : '' }} {{ suffixMessage }}</strong></p>
    <p>Once you start the exam, you must complete it without interruptions.</p>
  </ng-template>
</div>

<div class="modal-footer">
  <ng-container *ngIf="isSuccess; else actionButtons">
    <button type="button" class="btn btn-primary" (click)="modal.close('report')">View Report</button>
    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Close</button>
  </ng-container>

  <ng-template #actionButtons>
    <button type="button" class="btn btn-outline-secondary" (click)="goBack()">Go Back</button>
    <button type="button" class="btn btn-danger" (click)="confirmAttendExam()">{{ label || 'Confirm' }}</button>
  </ng-template>
</div>
